/*
 *
 * RecoveryAttemptsExceededModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 17-Oct-2024
*/

import RecoveryAttemptsExceededModal from './RecoveryAttemptsExceededModalContainer'

export default RecoveryAttemptsExceededModal
